import { Affix, Button, Indicator, Transition } from '@mantine/core';
import { IconRobot, IconTrophy } from '@tabler/icons-react';
import { useBotGame } from './BotContext';
import { COLORS } from '../config/constants';

/**
 * BotFloatingStatus component displays a floating action button that alerts the user
 * to game events and provides quick access to the bot management modal.
 * @param {Object} props - Component properties.
 * @param {Function} props.openModal - Function to open the management modal.
 * @param {boolean} props.isModalOpen - Whether the management modal is currently open.
 */
export function BotFloatingStatus({ openModal, isModalOpen }) {
    const { gameState, botCount, timeLeft, podium } = useBotGame();

    const visible = gameState !== 'lobby' && !isModalOpen;

    return (
        <Affix position={{ bottom: 20, right: 20 }}>
            <Transition transition="slide-up" mounted={visible}>
                {(transitionStyles) => (
                    <div style={transitionStyles}>
                        <Indicator
                            label={botCount}
                            size={22}
                            color="red"
                            withBorder
                            processing={gameState === 'question'} // Pulse animation when active
                            disabled={botCount === 0}
                        >
                            <Button
                                onClick={openModal}
                                leftSection={gameState === 'ended' ? <IconTrophy size={20} /> : <IconRobot size={20} />}
                                color={gameState === 'question' ? COLORS.GREEN : gameState === 'ended' ? COLORS.RED : COLORS.BLUE}
                                radius="xl"
                                size="md"
                                style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.3)' }}
                            >
                                {gameState === 'question'
                                    ? `Answer Now! (${Math.ceil(timeLeft / 1000)}s)`
                                    : gameState === 'ended'
                                        ? (podium.length > 0 ? "View Podium" : "Game Ended")
                                        : "Game Running..."}
                            </Button>
                        </Indicator>
                    </div>
                )}
            </Transition>
        </Affix>
    );
}